import React, { Component } from 'react';

import './QuoteBar.css';

class QuoteBar extends Component {
    render() {
        return (
            <div className="col-md-12 quote-bar">
                {this.props.text}
            </div>
        )
    }
}

QuoteBar.defaultProps = {
    text: (
        <div>
            <p>TROI creates learning design strategies and digital content for companies and universities.</p>
            <p>Does the quality of your current online material match your ambition?</p>
        </div>
    )
};

export default QuoteBar;



// WEBPACK FOOTER //
// ./src/components/QuoteBar.js